<template>
    <Modal :opened="opened" @close="close">
        <div v-loading="loading" class="tag-history__inner">
            <div class="tag-history__title">
                История изменений
            </div>

            <div v-if="isMobile" class="tag-history__list">
                <div
                    v-for="(item, index) in rows"
                    :key="`tag_row_${index}`"
                    class="tag-history__list-row"
                >
                    <div>
                        {{ rusDateTime(item.date) }} -
                        <span v-if="item.type === 'added'" class="green">Добавлен</span>
                        <span v-else class="red">Удален</span>
                    </div>
                    <div class="tag-history__tags">
                        <PortfolioUserTagItem
                            v-for="(tag, tagIndex) in item.tags"
                            class="tag-history__tag"
                            :key="`tag_item_${tagIndex}_${tag.id}`"
                            :catalog-item="tag"
                            :selected="item.type === 'added'"
                        />
                    </div>
                    <div>
                        <template v-if="!item.author || !item.author.userId">
                            {{ getAuthorName(item) }}
                        </template>
                        <template v-else>
                            <a
                                class="tag-history__link"
                                :href="getAuthorLink(item)"
                                target="_blank"
                            >
                                {{ getAuthorName(item) }}
                            </a>
                        </template>
                    </div>

                </div>
            </div>
            <table v-else class="tag-history__table">
                <thead>
                    <tr>
                        <th>Наименование тега</th>
                        <th>Статус</th>
                        <th>Дата и время изменений</th>
                        <th>Автор изменений</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(item, index) in rows"
                        :key="`tag_row_${index}`"
                    >
                        <td class="tag-history__tags">
                            <PortfolioUserTagItem
                                v-for="(tag, tagIndex) in item.tags"
                                class="tag-history__tag"
                                :key="`tag_item_${tagIndex}_${tag.id}`"
                                :catalog-item="tag"
                                outline
                            />
                        </td>
                        <td>
                            {{ item.type === 'added' ? 'Добавлен' : 'Удален' }}
                        </td>
                        <td>
                            {{ rusDateTime(item.date) }}
                        </td>
                        <td>
                            <template v-if="!item.author || !item.author.userId">
                                {{ getAuthorName(item) }}
                            </template>
                            <template v-else>
                                <a
                                    class="tag-history__link"
                                    :href="getAuthorLink(item)"
                                    target="_blank"
                                >
                                    {{ getAuthorName(item) }}
                                </a>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </Modal>
</template>

<script>
import Modal from "@/components/UI/Modal.vue";
import {mapActions, mapGetters} from "vuex";
import PortfolioUserTagItem from "@/components/portfolio/tags/PortfolioUserTagItem.vue";
import {rusDateTime} from "@/tools/date_format";

export default {
    name: "PortfoliUserTagsModal",
    components: { Modal, PortfolioUserTagItem },

    emits: ['close'],

    props: {
        opened: Boolean,
    },


    data: () => ({
        history: {
            total: 0,
            fields: {},
            list: [],
        },
        loading: false,
    }),


    async created() {
        await this.loadRegistryItems({ type: 'user_tags', withMeta: true });
        await this.load();
    },

    watch: {
        async opened (nv) {
            if (nv) {
                await this.load();
            }
        },
    },

    computed: {
        ...mapGetters([
            'isMobile',
        ]),
        ...mapGetters('data', [
            'getRegistryItems',
        ]),
        ...mapGetters('newUsers', [
            'getUser',
        ]),

        tagsList() {
            return this.getRegistryItems('user_tags');
        },

        tagListMapped() {
            const map = {};

            for (const item of this.tagsList) {
                map[item.id] = item;
            }

            return map;
        },

        rows() {
            const list = [];
            const fields = this.history.fields || {};
            const tagsHistory = fields.foreignTagsId || [];

            for (const itemOriginal of tagsHistory) {
                const item = {...itemOriginal};

                const added = item.newValue.filter(v => !item.oldValue.includes(v));
                const removed = item.oldValue.filter(v => !item.newValue.includes(v));

                if (added.length) {
                    list.push({
                        date: item.datetimeChange,
                        type: 'added',
                        author: item.author,
                        tags: added.map(id => (this.tagListMapped[id] || {
                            id,
                            field_value: `Неизвестный тег #${id}`,
                            meta: {
                                fill_color: '#eee',
                                text_color: '#fff',
                            },
                        })),
                    });
                }

                if (removed.length) {
                    list.push({
                        date: item.datetimeChange,
                        type: 'remove',
                        author: item.author,
                        tags: removed.map(id => (this.tagListMapped[id] || {
                            id,
                            field_value: `Неизвестный тег #${id}`,
                            meta: {
                                fill_color: '#eee',
                                text_color: '#fff',
                            },
                        })),
                    });
                }
            }

            return list;
        },
    },

    methods: {
        rusDateTime,
        ...mapActions('data', [
            'loadRegistryItems',
        ]),
        ...mapActions('newUsers', [
            'loadChangeLogHistory',
        ]),

        getAuthorName(item) {
            const author = item.author;

            if (!author || !author.userId) {
                return 'Система';
            }

            return [author.name, author.surname].filter(v => v).join(' ') || `(User #${author.userId})`;
        },

        getAuthorLink(item) {
            return this.$router.resolve({
                name: 'participant',
                params: {
                    id: item.author.userId,
                },
            }).href;
        },

        async load() {
            this.loading = true;

            const res = await this.loadChangeLogHistory({
                userId: this.getUser.userId,
                fields: ['foreignTagsId'],
            });

            this.history.total = res.total;
            this.history.fields = res.fields;

            this.loading = false;
        },

        close() {
            this.$emit('close');
        },
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import '~@/styles/variables';

.tag-history {
    &__inner {
        width: 100%;

        @include on-desktop {
            width: rem(896);
        }
    }
    &__title {
        font-weight: 700;
        font-size: mrem(32);
        line-height: mrem(40);
        padding-bottom: mrem(38);

        @include on-desktop {
            font-size: rem(32);
            line-height: rem(40);
            padding-bottom: rem(38);
        }
    }

    &__tags {
        display: flex;
        gap: mrem(16);

        @include on-desktop {
            gap: rem(16);
        }

        :deep(.user-portfolio-tag-item) {
            font-weight: 600;
            font-size: mrem(12);
            line-height: mrem(20);
            cursor: initial;

            @include on-desktop {
                font-size: rem(12);
                line-height: rem(20);
            }
        }
    }

    &__link {
        color: $color-main-blue;
        font-weight: 600;
        text-decoration: underline;
    }

    &__table {
        width: 100%;
        border-spacing: 0;

        font-weight: 400;
        font-size: mrem(12);
        line-height: mrem(20);

        @include on-desktop {
            font-size: rem(12);
            line-height: rem(20);
        }

        thead {
            tr:last-child {
                th {
                    border-bottom: none;
                }
            }
            tr {
                th:not(:last-child) {
                    border-right: none;
                }
            }
            th:first-child {
                border-radius: mrem(10) 0 0 0;
                @include on-desktop { border-radius: rem(10) 0 0 0; }
            }
            th:last-child {
                border-radius: 0 mrem(10) 0 0;
                @include on-desktop { border-radius: 0 rem(10) 0 0; }
            }
        }

        tbody {
            tr {
                td:not(:last-child) {
                    border-right: none;
                }
            }

            tr:not(:last-child) {
                td {
                    border-bottom: none;
                }
            }

            tr:last-child {
                td:first-child {
                    border-radius: 0 0 0 mrem(10);
                    @include on-desktop { border-radius: 0 0 0 rem(10); }
                }
                td:last-child {
                    border-radius: 0 0 mrem(10) 0;
                    @include on-desktop { border-radius: 0 0 rem(10) 0; }
                }
            }
        }

        th, td {
            text-align: left;
            padding: mrem(16);
            border: mrem(1) solid $color-main-primary-light;

            @include on-desktop {
                border: rem(1) solid $color-main-primary-light;
                padding: rem(16);
            }
        }
    }

    &__list-row {
        display: flex;
        flex-direction: column;
        gap: mrem(16);
        border-bottom: mrem(1) solid $color-main-primary-light;
        padding: mrem(20) 0;

        @include on-desktop {
            gap: rem(16);
            border-bottom: rem(1) solid $color-main-primary-light;
            padding: rem(20) 0;
        }

        &:first-child {
            padding-top: 0;
        }
        &:last-child {
            border-bottom: none;
        }

        .green {
            color: $color-main-green;
        }

        .red {
            color: $color-main-red;
        }
    }
}
</style>
